var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogosDribbbleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22_523",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22_523)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 32,
    height: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66429 21.0214C10.6179 16.4786 13.6714 12.6964 17.775 10.7679C18.1607 11.2929 20.775 14.925 23.2071 19.2321C16.35 21.0536 10.3179 21.0321 9.66429 21.0214ZM33.7071 13.0714C30.1071 9.87857 25.2107 8.66785 20.5714 9.79285C20.9786 10.3393 23.6357 13.9607 26.0357 18.3643C31.2429 16.4036 33.4393 13.4464 33.7071 13.0714ZM15.0107 35.5714C19.35 38.9571 25.0071 39.5036 29.7214 37.5C29.5071 36.2143 28.65 31.7357 26.5929 26.4C20.6893 28.4143 16.5429 32.4428 15.0107 35.5714ZM25.5964 23.9786C25.2321 23.1428 24.825 22.3179 24.4071 21.4929C17.1 23.6786 10.0071 23.5928 9.36429 23.5714C9.36429 23.7214 9.35357 23.8714 9.35357 24.0214C9.35357 27.7821 10.7786 31.2107 13.1143 33.8143C15.4929 29.7536 20.3036 25.4678 25.5964 23.9786ZM29.3357 25.725C31.2536 30.9857 32.025 35.2714 32.175 36.1607C35.4643 33.9428 37.8 30.4178 38.4536 26.3464C37.9607 26.1857 33.9214 24.9857 29.3357 25.725ZM27.1607 20.5393C27.675 21.5893 28.05 22.4464 28.4464 23.4107C33.3214 22.8 38.1643 23.775 38.6464 23.8821C38.6143 20.4214 37.3821 17.25 35.3357 14.7643C35.025 15.1821 32.5714 18.3214 27.1607 20.5393ZM48 5.14286V42.8571C48 45.6964 45.6964 48 42.8571 48H5.14286C2.30357 48 0 45.6964 0 42.8571V5.14286C0 2.30357 2.30357 0 5.14286 0H42.8571C45.6964 0 48 2.30357 48 5.14286ZM41.1429 24C41.1429 14.55 33.45 6.85714 24 6.85714C14.55 6.85714 6.85714 14.55 6.85714 24C6.85714 33.45 14.55 41.1428 24 41.1428C33.45 41.1428 41.1429 33.45 41.1429 24Z",
    fill: "#EA4C89"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosDribbbleIcon);
export default __webpack_public_path__ + "static/media/logos_dribbble-icon.eb893d8eb59694bc21c2095eaa4b1939.svg";
export { ForwardRef as ReactComponent };